import { IWT_LIGHT_THEME } from './light.mjs';
import { IWT_DARK_THEME } from './dark.mjs';
export const IWT_THEME={light: IWT_LIGHT_THEME, dark: IWT_DARK_THEME};
